import { editorUrlConverter } from "../../../utils/editorLinks";
import {
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  notification,
  Popconfirm,
  Radio,
  Select,
  Switch,
  Tag,
  Tooltip,
} from "antd";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Editor } from "@tinymce/tinymce-react";
import axios from "../../../config/axiosInstance";
import moment from "moment";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  BsClock,
  BsUpload,
  BsInfoCircle,
  BsBodyText,
  BsImage,
  BsGear,
  BsTag,
} from "react-icons/bs";
import { HiMicrophone, HiRefresh } from "react-icons/hi";
import { IoCopyOutline } from "react-icons/io5";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import LinearProgress from "@mui/material/LinearProgress";

import { API } from "../../../config/API";
import Loadingbox from "../../../component/loadingbox";
import ImagePicker from "../../../component/imagePicker";
import ImageItem from "../../../component/imageItem";
import { uploadImageToS3 } from "../../../config/s3config/s3fileUpload";
import {
  LoadTags,
  LoadCategories,
  LoadSubCategories,
} from "../../../utils/commonapis";
import { CREATELOGS } from "../../../utils/apirequest";
import { addTags, getNewsById } from "../../newsScreen/utils/apiRequest";
import {
  refreshArticleCache,
  refreshNewsCache,
} from "../../newsScreen/helpers/cache";
import SocialShare from "../../newsScreen/component/socialShareView";
import NewsLog from "../../../component/newsLog";
import { SiGoogleanalytics } from "react-icons/si";
import { MdPublishedWithChanges } from "react-icons/md";
import Audiorecorder from "../../../component/audio-recorder/index";
import AudioUpload from "../../../assets/image/Group 269.svg";
import { PreviewData } from "../../newsScreen/utils/formactions";
import PreviewModal from "../../../component/previewSession/preview";
import mic from "../../../assets/image/dots-loading.gif";
import { GetNjayarCat } from "../../njayarPrabhaadham/queries/getNjayarCategory";
import AlsoRead from "../../../component/alsoReadModal";
import SocialEmbedModal from "../../../component/socialEmbedModal";
import MediaJoin from "../../../component/joinSocialMedia";

import ContentTypeSelector from "./contentTypeSelector";
import {
  ContentType,
  CONTENT_TYPE_LABELS,
  isFieldVisible,
} from "./fieldConfig";
import {
  API_ENDPOINTS,
  URL_PATTERNS,
  buildPayload,
  parseResponse,
  parseImages,
} from "./apiMapper";

import "../styles.css";
import TextArea from "antd/es/input/TextArea";

dayjs.extend(utc);
dayjs.extend(timezone);

function UnifiedForm() {
  const navigate = useNavigate();
  const { type: routeType, id, masterId } = useParams<{ type?: string; id?: string; masterId?: string }>();
  const [searchParams] = useSearchParams();
  const User = useSelector((state: any) => state.User.user);

  const isEditing = !!id;
  const initialContentType: ContentType =
    (routeType as ContentType) ||
    (searchParams.get("type") as ContentType) ||
    (masterId ? "njayar" : "news");

  const [contentType, setContentType] =
    useState<ContentType>(initialContentType);
  const [form] = Form.useForm();

  const [content, setContent] = useState<string>("");
  const [blurb, setBlurb] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [editorLoading, setEditorLoading] = useState(true);
  const [publishLoading, setPublishLoading] = useState(false);
  const [scheduleLoading, setScheduleLoading] = useState(false);

  const [data, setData] = useState<any>(null);
  const [returnedId, setReturnedId] = useState<any>(null);

  const [imageuploaddata, setImageuploaddata] = useState<any>({
    imageurl1: "",
    imageurl2: "",
    imageurl3: "",
  });
  const [authorImg, setAuthorImg] = useState<string>("");
  const [imageUploader, setImageUploader] = useState(false);
  const [imageType, setImageType] = useState("");
  const [imageName, setImageName] = useState("");

  const [audiouploader, setAudiouploader] = useState<string>("");
  const [audioRecorderVisible, setAudioRecorderVisible] = useState(false);

  const [tags, setTags] = useState<any[]>([]);
  const [tagFilter, setTagFilters] = useState("");
  const [tagLoading, setTagLoading] = useState(false);

  const [categories, setCategories] = useState<any[]>([]);
  const [subcategories, setSubcategories] = useState<any[]>([]);
  const [njayarCategories, setNjayarCategories] = useState<any[]>([]);

  const [scheduled, setScheduled] = useState<dayjs.Dayjs | null>(null);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [tempScheduled, setTempScheduled] = useState<dayjs.Dayjs | null>(null);
  const [socialEmbed, setSocialEmbed] = useState<{
    embed_type?: string;
    social_embed?: string;
  }>({});
  const [embedType, setEmbedType] = useState<string>("");
  const [socialEmbedModal, setSocialEmbedModal] = useState(false);
  const [alsoRead, setAlsoRead] = useState(false);
  const [customButton, setCustomButton] = useState(false);
  const [datamodal, setDatamodal] = useState<any>({});
  const [microphone, setMicrophone] = useState(false);
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [showPreview, setShowPreview] = useState(false);
  const [previewDatas, setPreviewDatas] = useState<any>();
  const [socialShareModal, setSocialShareModal] = useState(false);
  const [newsLogVisible, setNewsLogVisible] = useState(false);

  // =================== Load Data ===================

  useEffect(() => {
    loadTags(tagFilter);
  }, [tagFilter]);

  useEffect(() => {
    if (contentType === "news") {
      loadCategories();
      loadSubCategories();
    }
    if (contentType === "njayar") {
      loadNjayarCategories();
    }
  }, [contentType]);

  useEffect(() => {
    if (isEditing && id) loadEditData(id);
  }, []);

  useEffect(() => {
    if (masterId && contentType === "njayar") {
      form.setFieldsValue({ masterid: masterId });
    }
  }, [masterId, contentType]);

  const loadTags = async (searchTerm: any) => {
    setTagLoading(true);
    try {
      const res: any = await LoadTags(searchTerm);
      setTags(res);
    } catch {
    } finally {
      setTagLoading(false);
    }
  };

  function debounce(func: any, delay: any) {
    let timer: any;
    return (...args: any) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  const OnTagSearch = debounce((value: any) => setTagFilters(value), 200);

  const loadCategories = async () => {
    try {
      const res: any = await LoadCategories();
      setCategories(res?.data || []);
    } catch {}
  };

  const loadSubCategories = async () => {
    try {
      const res: any = await LoadSubCategories();
      setSubcategories(res?.data || []);
    } catch {}
  };

  const loadNjayarCategories = async () => {
    try {
      const result = await GetNjayarCat();
      if (result.status) {
        const res = result.data?.data.filter(
          (item: any) => item?.attributes?.category?.length,
        );
        const uniqueCategories = res?.reduce((acc: string[], current: any) => {
          const category = current?.attributes?.category;
          if (!acc.includes(category)) acc.push(category);
          return acc;
        }, []);
        setNjayarCategories(uniqueCategories || []);
      }
    } catch {}
  };

  const loadEditData = async (editId: string) => {
    const endpoints = API_ENDPOINTS[contentType];
    const url = API.BASE_URL + endpoints.getById(editId);
    try {
      const response: any = await getNewsById(url);
      if (!response) return;
      let rawData: any;
      if (contentType === "news") {
        rawData = response?.data;
      } else {
        rawData = response?.data?.data;
      }
      setData(rawData);

      const parsed = parseResponse(contentType, rawData);
      const images = parseImages(contentType, rawData);

      form.setFieldsValue({
        heading: parsed.heading || "",
        title: parsed.title || "",
        author: parsed.author || "",
        permalink: parsed.permalink || "",
        seriesName: parsed.seriesName || "",
        tagString: parsed.tagString || [],
        tags: parsed.tags || [],
        onlive: parsed.onlive || false,
        isHighPriority: parsed.isHighPriority,
        metaTitle: parsed.metaTitle || "",
        metaDescription: parsed.metaDescription || "",
        njayarCategory: parsed.njayarCategory || [],
      });

      if (contentType === "news") {
        const attrs = rawData?.attributes || rawData;
        if (attrs?.categories) {
          const catValues = Array.isArray(attrs.categories)
            ? attrs.categories.map((c: any) =>
                JSON.stringify({ id: c.id || c, category: c.category || "" }),
              )
            : [];
          form.setFieldsValue({ categories: catValues });
        }
        if (attrs?.Subcategories) {
          const subCatIds = attrs.Subcategories.map((item: any) => item.id);
          form.setFieldsValue({ subcategory: subCatIds });
        }
      }

      const attrs = rawData?.attributes || rawData;
      if (contentType === "vidya" || contentType === "njayar")
        setContent(attrs?.Body || "");
      else setContent(attrs?.body || "");
      if (contentType === "news") setBlurb(attrs?.title || "");

      setImageuploaddata({
        imageurl1: images.imageurl1,
        imageurl2: images.imageurl2,
        imageurl3: images.imageurl3,
      });
      setAuthorImg(images.authorImg);
      setAudiouploader(attrs?.audio || "");

      if (contentType === "news") {
        setSocialEmbed({
          embed_type: attrs?.embed_type || "",
          social_embed: attrs?.social_embed || "",
        });
        setEmbedType(attrs?.embed_type || "");
      }
      if (attrs?.scheduled_at)
        setScheduled(dayjs(attrs.scheduled_at).tz("Asia/Kolkata"));

      setDatamodal({
        image1Value: attrs?.image1_description || "",
        image2Value: attrs?.image2_description || "",
        image3Value: attrs?.image3_description || "",
        image1Caption: attrs?.image1_caption || "",
      });

      setReturnedId(rawData?.id);
    } catch (error) {
      console.error("Error loading data:", error);
      message.error("Failed to load data");
    }
  };

  // =================== Image Handlers ===================

  const addImagesToList = (imgData: any) => {
    try {
      let DataObj = { ...imageuploaddata };
      if (imgData.type === "image1") {
        DataObj.imageurl1 = imgData.image_url;
        setDatamodal((prev: any) => ({
          ...prev,
          image1Value: imgData.image_desc || "",
          image1Caption: imgData.image_Caption || "",
        }));
      } else if (imgData.type === "image2") {
        DataObj.imageurl2 = imgData.image_url;
        setDatamodal((prev: any) => ({
          ...prev,
          image2Value: imgData.image_desc || "",
        }));
      } else if (imgData.type === "image3") {
        DataObj.imageurl3 = imgData.image_url;
        setDatamodal((prev: any) => ({
          ...prev,
          image3Value: imgData.image_desc || "",
        }));
      } else if (imgData.type === "authorImg") {
        setAuthorImg(imgData.image_url);
        return;
      }
      setImageuploaddata(DataObj);
    } catch (err) {
      console.log(err);
    }
  };

  const addImageToEditor = (image: any) => {
    if (window.tinymce && window.tinymce.activeEditor) {
      const editor = window.tinymce.activeEditor;
      const alt =
        image?.image_desc ||
        `${moment().format("YYYY-MM-DDHH:MM:SS")}.suprabhaatham-news.png`;
      editor.insertContent(
        `<div style="display: inline-block; text-align: center;">
          <img src="${image?.image_url}" alt="${alt}" style="max-width: 100%; display: block; margin: 0 auto;" onload="this.parentElement.style.width = this.width + 'px';" />
          <div style="display: flex; justify-content: space-between; margin-top: 5px;">
            <div style="flex: 1; text-align: left;">${image?.image_desc || ""}</div>
            <div style="flex: 1; text-align: right;">${image?.image_Caption || ""}</div>
          </div>
        </div>`,
      );
      setImageUploader(false);
    }
  };

  const deleteImagesFromList = (key: string) => {
    try {
      setImageuploaddata((prev: any) => ({ ...prev, [key]: "" }));
      notification.success({ message: "Image Removed" });
    } catch {
      notification.error({ message: "Failed to remove" });
    }
  };

  // =================== Form Submission ===================

  const handleAction = async (
    action: "save" | "publish" | "schedule" = "save",
    scheduleTime?: dayjs.Dayjs | null,
  ) => {
    // Validate form
    try {
      await form.validateFields();
    } catch {
      return;
    }

    // Schedule validation
    const effectiveSchedule =
      scheduleTime !== undefined ? scheduleTime : scheduled;
    if (action === "schedule" && !effectiveSchedule) {
      message.error("Please select a scheduled date and time");
      return;
    }

    if (action === "publish") setPublishLoading(true);
    else if (action === "schedule") setScheduleLoading(true);
    else setLoading(true);

    try {
      const values = form.getFieldsValue();
      const endpoints = API_ENDPOINTS[contentType];
      const { imageurl1, imageurl2, imageurl3 } = imageuploaddata;
      const existingId = returnedId || data?.id;

      const formPayload: Record<string, any> = {};
      formPayload.heading = values.heading;
      if (v("title"))
        formPayload.title = contentType === "news" ? blurb : values.title;
      formPayload.body = content;
      if (v("author")) formPayload.author = values.author;
      formPayload.image1 = imageurl1;
      if (v("image2")) formPayload.image2 = imageurl2;
      if (v("socialImage")) formPayload.socialImage = imageurl3;
      if (v("authorImage")) formPayload.authorImage = authorImg || imageurl3;
      if (v("image1Description"))
        formPayload.image1Description = datamodal.image1Value || "";
      if (v("image2Description"))
        formPayload.image2Description = datamodal.image2Value || "";
      if (v("image3Description"))
        formPayload.image3Description = datamodal.image3Value || "";
      if (v("image1Caption"))
        formPayload.image1Caption = datamodal.image1Caption || "";
      if (v("audio")) formPayload.audio = audiouploader || null;
      formPayload.permalink = values.permalink || "";
      if (v("tagString"))
        formPayload.tagString = (values.tagString || []).join("|");
      if (contentType === "vidya" && v("tags"))
        formPayload.tags = values.tags || [];
      if (v("categories")) {
        const selectedCategories = (values.categories || []).map((val: any) =>
          JSON.parse(val),
        );
        formPayload.categories = selectedCategories.map((c: any) => c.id);
        formPayload.tagsArray = selectedCategories
          .map((item: any) => "%" + item?.category?.toLowerCase())
          .join("");
      }
      if (v("subcategories"))
        formPayload.subcategories = values.subcategory || [];
      if (v("njayarCategory"))
        formPayload.njayarCategory = (values.njayarCategory || []).join("|");
      if (v("seriesName")) formPayload.seriesName = values.seriesName || "";
      if (v("isHighPriority"))
        formPayload.isHighPriority = values.isHighPriority;
      if (v("onlive")) formPayload.onlive = values.onlive || false;

      // Handle scheduled_at based on content type and action
      if (contentType === "news") {
        if (action === "publish") {
          formPayload.scheduled_at = null;
        } else {
          formPayload.scheduled_at = effectiveSchedule
            ? effectiveSchedule.toISOString()
            : null;
        }
      } else if (v("scheduled_at")) {
        formPayload.scheduled_at = effectiveSchedule
          ? effectiveSchedule.toISOString()
          : null;
      }

      if (v("metaTitle")) formPayload.metaTitle = values.metaTitle || "";
      if (v("metaDescription"))
        formPayload.metaDescription = values.metaDescription || "";
      if (v("socialEmbed"))
        formPayload.socialEmbed = socialEmbed?.social_embed || null;
      if (v("embedType"))
        formPayload.embedType = socialEmbed?.embed_type || embedType || null;
      if (v("masterid")) formPayload.masterid = values.masterid || "";

      const extraData: Record<string, any> = {
        user: existingId ? data?.user?.id || User?.id : User?.id,
      };
      // Link the article to its issue via the relation (masterid is only a string).
      if (contentType === "njayar" && masterId) extraData.masterId = Number(masterId);

      // Action-aware publishedAt per content type
      if (contentType === "news") {
        const attrs = data?.attributes || data;
        if (action === "publish") {
          extraData.publishedAt = new Date();
        } else if (action === "schedule") {
          extraData.publishedAt = null;
        } else if (isEditing) {
          extraData.publishedAt = attrs?.publishedAt || null;
        } else {
          extraData.publishedAt = null;
        }
        extraData.editing_Status = false;
        extraData.liveEditingUser = "null";
      } else if (contentType === "article") {
        if (action === "publish") {
          extraData.publishedAt = new Date();
        } else {
          const attrs = data?.attributes || data;
          extraData.publishedAt = existingId
            ? attrs?.publishedAt || null
            : null;
        }
      } else if (contentType === "vidya") {
        extraData.publishedAt = scheduled
          ? null
          : (data?.attributes || data)?.publishedAt || null;
      } else {
        const attrs = data?.attributes || data;
        extraData.publishedAt = existingId ? attrs?.publishedAt || null : null;
      }

      const payload = buildPayload(contentType, formPayload, extraData);
      let url: string;
      let method: string;

      if (existingId) {
        url = API.BASE_URL + endpoints.update(existingId);
        method = "PUT";
        if (contentType === "news")
          url = API.BASE_URL + `${API.UPDATE_NEWS}/${existingId}/${User?.id}`;
      } else {
        url = API.BASE_URL + endpoints.create;
        method = "POST";
      }

      const response = await axios({ method, url, data: payload });
      const responseId = response?.data?.data?.id || response?.data?.id;
      setReturnedId(responseId);

      const allTags = [...(values.tagString || []), ...(values.tags || [])];
      if (allTags.length > 0) addTags(allTags);

      if (contentType === "article") {
        CREATELOGS({
          userId: User?.id,
          itemId: responseId,
          payload,
          type: "articles",
        });
      }

      setLoading(false);
      setPublishLoading(false);
      setScheduleLoading(false);

      const njayarMasterRoute = contentType === "njayar" && masterId
        ? `/Auth/unified-content/njayar/master/${masterId}`
        : null;

      if (action === "publish") {
        message.success("Published Successfully");
        navigate(njayarMasterRoute || "/Auth/unified-content");
      } else if (action === "schedule") {
        message.success("Scheduled Successfully");
        navigate(njayarMasterRoute || "/Auth/unified-content");
      } else {
        message.success(
          `${CONTENT_TYPE_LABELS[contentType]} ${existingId ? "Updated" : "Created"} Successfully`,
        );
        if (contentType === "njayar" && masterId) {
          // Stay on the same page so Publish button appears
        } else if (contentType === "article" && !existingId) {
          window.location.replace(
            `/Auth/unified-content/edit/article/${responseId}`,
          );
        }
      }
    } catch (error) {
      console.error("Submit error:", error);
      setLoading(false);
      setPublishLoading(false);
      setScheduleLoading(false);
      message.error("Failed to save");
    }
  };

  // =================== Publish & Schedule ===================

  const onPublish = async () => {
    const publishId = returnedId || data?.id;
    if (!publishId) return;
    setPublishLoading(true);
    const endpoints = API_ENDPOINTS[contentType];
    try {
      if (contentType === "news") {
        await axios.put(API.BASE_URL + `${API.PUBLISH_NEWS}/${publishId}`);
      } else {
        await axios.put(API.BASE_URL + endpoints.publish(publishId), {
          data: { publishedAt: new Date(), scheduled_at: null },
        });
      }
      message.success("Published Successfully");
      setPublishLoading(false);
      navigate(
        contentType === "njayar" && masterId
          ? `/Auth/unified-content/njayar/master/${masterId}`
          : "/Auth/unified-content"
      );
    } catch {
      setPublishLoading(false);
      message.error("Failed to publish");
    }
  };

  const onSchedule = async () => {
    const scheduleId = returnedId || data?.id;
    if (!scheduleId || !scheduled) {
      message.error("Please select a scheduled date and time");
      return;
    }
    setScheduleLoading(true);
    const endpoints = API_ENDPOINTS[contentType];
    try {
      await axios.put(API.BASE_URL + endpoints.publish(scheduleId), {
        data: { scheduled_at: scheduled.toISOString(), publishedAt: null },
      });
      message.success("Scheduled Successfully");
      setScheduleLoading(false);
      navigate(
        contentType === "njayar" && masterId
          ? `/Auth/unified-content/njayar/master/${masterId}`
          : "/Auth/unified-content"
      );
    } catch {
      setScheduleLoading(false);
      message.error("Failed to schedule");
    }
  };

  // =================== URL Copy ===================

  const handleUrlCopy = (action: "copy" | "preview") => {
    const perma = form.getFieldValue("permalink");
    const formattedPerma = perma?.replace(/\s+/g, "-") || "";
    const itemId = returnedId || data?.id;
    if (!itemId) return;
    const link = URL_PATTERNS[contentType](itemId, formattedPerma);
    if (action === "copy") {
      navigator.clipboard
        .writeText(link)
        .then(() => message.success("Link copied"));
    } else {
      window.open(link, "_blank");
    }
  };

  const checkPermaLink = (e: any) => {
    const regex = /^[a-zA-Z0-9- ]*$/;
    const inputValue = e.target.value;
    const filteredValue = inputValue
      .split("")
      .filter((char: any) => regex.test(char))
      .join("");
    form.setFieldsValue({ permalink: filteredValue });
  };

  // =================== Social Embed & Also Read (News) ===================

  const cleanTwitterEmbed = (embedCode: string) => {
    if (!embedCode) return "";
    let cleaned = embedCode.trim();
    if (
      cleaned.includes("<blockquote") &&
      !cleaned.includes('class="twitter-tweet"')
    ) {
      cleaned = cleaned.replace(
        /<blockquote([^>]*)>/,
        '<blockquote class="twitter-tweet"$1>',
      );
    }
    if (!cleaned.includes("platform.twitter.com/widgets.js")) {
      cleaned +=
        ' <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>';
    }
    return cleaned;
  };

  const cleanInstagramEmbed = (embedCode: string) => {
    if (!embedCode) return "";
    let cleaned = embedCode.trim();
    if (
      cleaned.includes("<blockquote") &&
      !cleaned.includes('class="instagram-media"')
    ) {
      cleaned = cleaned.replace(
        /<blockquote([^>]*)>/,
        '<blockquote class="instagram-media"$1>',
      );
    }
    if (
      cleaned.includes("<blockquote") &&
      !cleaned.includes("data-instgrm-permalink")
    ) {
      const urlMatch = cleaned.match(
        /https:\/\/(?:www\.)?instagram\.com\/p\/[^\/\s"']*/,
      );
      if (urlMatch) {
        cleaned = cleaned.replace(
          /<blockquote([^>]*class="instagram-media"[^>]*)>/,
          `<blockquote$1 data-instgrm-permalink="${urlMatch[0]}/" data-instgrm-version="14">`,
        );
      }
    }
    if (!cleaned.includes("instagram.com/embed.js")) {
      cleaned += ' <script async src="//www.instagram.com/embed.js"></script>';
    }
    return cleaned;
  };

  const addSocialEmbed = (embedData: any) => {
    try {
      if (window.tinymce && window.tinymce.activeEditor) {
        const editor = window.tinymce.activeEditor;
        let embedContent = embedData.social_embed || "";
        if (embedData.embed_type === "twitter") {
          embedContent = cleanTwitterEmbed(embedContent);
        } else if (embedData.embed_type === "instagram") {
          embedContent = cleanInstagramEmbed(embedContent);
        }
        const embedWrapper = `<div style="text-align: center; margin: 20px 0;">${embedContent}</div>`;
        editor.insertContent(embedWrapper);
        setSocialEmbed(embedData);
        setSocialEmbedModal(false);
        message.success(
          `${embedData.embed_type || "Social media"} embed added successfully!`,
        );
      }
    } catch (err) {
      console.log("Error adding social embed:", err);
      message.error("Failed to add social embed. Please try again.");
    }
  };

  const addAlsoRead = (alsoReadContent: any) => {
    try {
      const styles = `background-color: transparant; border: 1px solid #a1a1a1; border-left: none; border-right: none; padding-left:20px; padding-right:20px; padding: 8px; margin-vertical: 10px; cursor: pointer;`;
      if (window.tinymce && window.tinymce.activeEditor) {
        const editor = window.tinymce.activeEditor;
        editor.insertContent(
          `<a href="${alsoReadContent.link}" target="_blank">
            <button style="${styles}"><strong style="color: #3f70d1;">ALSO READ: </strong><span style="color: #000; font-weight: 700;">${alsoReadContent.content}</span></button>
           </a>`,
        );
        setAlsoRead(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const addButtonMedia = (buttonContent: any) => {
    let color = "";
    if (buttonContent.media === "Whatsapp") {
      color = "#00e676";
    } else if (buttonContent.media === "Telegram") {
      color = "#64b5f6";
    } else {
      color = "#f50057";
    }
    const styles = `color: white; font-size: 16px;background:${color}; border:none; border-radius:25px;height:50px;text-align: center; padding-left:20px; padding-right:20px`;
    if (window.tinymce && window.tinymce.activeEditor) {
      const editor = window.tinymce.activeEditor;
      editor.insertContent(
        `<a href="${buttonContent.Link}" target="_blank"><button style="${styles}" >${buttonContent?.Text}</button></a>`,
      );
      setCustomButton(false);
    }
  };

  // =================== Preview ===================

  const previewData = () => {
    if (contentType === "news") {
      const body = {
        items: data,
        titleValue: blurb,
        body: content,
        tags: tags,
        pic1: imageuploaddata?.imageurl1,
        imageBase64: "",
      };
      const previewForm = {
        getFieldValue: (key: string) => {
          const map: Record<string, string> = {
            head: "heading",
            tags: "tagString",
            categories: "categories",
            author_name: "author",
          };
          return form.getFieldValue(map[key] || key);
        },
      };
      const pData = PreviewData(previewForm, body);
      setPreviewDatas(pData);
      setShowPreview(true);
    }
  };

  // =================== Speech Recognition ===================

  const handleListening = () => {
    setMicrophone(!microphone);
    if (!microphone) {
      SpeechRecognition.startListening({ language: "ml-IN" });
    } else {
      SpeechRecognition.stopListening();
      setContent((prev) => prev + transcript);
    }
  };

  const confirmResetContent = () => {
    resetTranscript();
    setContent("");
  };

  // =================== Editor Config ===================

  const editorInit = {
    height: 500,
    menubar: true,
    directionality: "ltr" as const,
    // Keep URLs exactly as entered and repair pasted "headline + URL" strings
    // (see src/utils/editorLinks.ts).
    convert_urls: false,
    urlconverter_callback: editorUrlConverter,
    plugins:
      "advlist autolink lists link image pageembed code preview charmap print preview anchor help searchreplace visualblocks code insertdatetime media table paste wordcount pageembed code preview image code",
    toolbar1:
      "  | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent |subscript superscript |link unlink | forecolor backcolor | | image | myCustomButton | help |",
    toolbar2:
      contentType === "news"
        ? "joinButton | alsoRead | socialEmbed"
        : undefined,
    setup: (editor: any) => {
      editor.ui.registry.addButton("myCustomButton", {
        text: "Media Library",
        icon: "gallery",
        onAction: () => {
          setImageType("Media");
          setImageUploader(true);
        },
      });
      if (contentType === "news") {
        editor.ui.registry.addButton("joinButton", {
          text: "Custom Button",
          onAction: () => {
            setCustomButton(true);
          },
        });
        editor.ui.registry.addButton("alsoRead", {
          text: "Add Also Read",
          onAction: () => {
            setAlsoRead(true);
          },
        });
        editor.ui.registry.addButton("socialEmbed", {
          text: "Social Embed",
          onAction: () => {
            setSocialEmbedModal(true);
          },
        });
      }
    },
    file_browser_callback_types:
      contentType === "news" ? "image media" : "image",
    file_picker_callback: function (callback: any, _value: any, meta: any) {
      if (meta.filetype === "image" || meta.filetype === "media") {
        const input = document.getElementById("my-file") as any;
        input.click();
        input.onchange = function () {
          const file = input.files[0];
          uploadImageToS3(file)
            .then((s3ImageUrl: any) =>
              callback(s3ImageUrl.Location, { alt: file.name }),
            )
            .catch((error: any) =>
              console.error("Error uploading image to S3:", error),
            );
        };
      }
    },
    paste_data_images: true,
  };

  const v = (field: string) => isFieldVisible(contentType, field as any);

  const publishedStatus = (() => {
    const attrs = data?.attributes || data;
    if (!attrs) return null;
    if (attrs.publishedAt) return "published";
    if (attrs.scheduled_at) return "scheduled";
    return "draft";
  })();

  // =================== Render ===================

  return (
    <div className="uc-form-page">
      {/* ---- Top Bar ---- */}
      <div className="uc-topbar">
        <div className="uc-topbar-row">
          <div
            className="uc-topbar-back"
            onClick={() => navigate(
              contentType === "njayar" && masterId
                ? `/Auth/unified-content/njayar/master/${masterId}`
                : "/Auth/unified-content"
            )}
          >
            <IoArrowBackCircleOutline />
          </div>
          <div>
            <div className="uc-topbar-title">
              {isEditing ? "Edit" : "Create"} {CONTENT_TYPE_LABELS[contentType]}
            </div>
          </div>
          <div className="uc-topbar-spacer" />
          <div className="uc-topbar-actions">
            {isEditing && publishedStatus === "published" && (
              <Tag className="uc-status-published">Published</Tag>
            )}
            {isEditing && publishedStatus === "scheduled" && (
              <Tag className="uc-status-scheduled">Scheduled</Tag>
            )}
            {isEditing && publishedStatus === "draft" && (
              <Tag className="uc-status-draft">Draft</Tag>
            )}
            {contentType === "news" && (
              <Button
                onClick={previewData}
                disabled={!(returnedId || data?.id)}
              >
                Preview
              </Button>
            )}
            {(contentType === "news" || contentType === "article") && (
              <Button
                icon={<HiRefresh />}
                onClick={() =>
                  contentType === "article"
                    ? refreshArticleCache()
                    : refreshNewsCache(returnedId || data?.id)
                }
                disabled={!(returnedId || data?.id)}
              >
                Cache
              </Button>
            )}
            {(returnedId || data?.id) && (
              <Button onClick={() => handleUrlCopy("preview")}>
                Website Preview
              </Button>
            )}
            <Button
              type="primary"
              onClick={() =>
                window.location.replace("/Auth/unified-content/create")
              }
            >
              Create New +
            </Button>
          </div>
        </div>
      </div>
      {loading && <LinearProgress color="primary" style={{ height: 2 }} />}

      {/* ---- Form ---- */}
      <Form
        onFinish={() => handleAction("save")}
        form={form}
        name="unified-content-form"
        scrollToFirstError
      >
        <div className="uc-form-body">
          {/* Content Type Selector */}
          <div className="uc-type-bar">
            <ContentTypeSelector
              value={contentType}
              onChange={setContentType}
              disabled={isEditing}
            />
          </div>

          <Row>
            {/* =================== Main Column =================== */}
            <Col sm={9} xs={12}>
              {/* Card: Basic Info */}
              <div className="uc-card">
                <div className="uc-card-title">
                  <BsInfoCircle /> Basic Information
                </div>
                <Row>
                  <Col
                    sm={contentType === "news" ? 12 : v("title") ? 6 : 12}
                    xs={12}
                  >
                    <label className="uc-label">Heading *</label>
                    <Form.Item
                      name="heading"
                      rules={[
                        { required: true, message: "Heading is required" },
                      ]}
                    >
                      <TextArea rows={2} placeholder="Enter heading" />
                    </Form.Item>
                  </Col>
                  {v("title") && contentType !== "news" && (
                    <Col sm={6} xs={12}>
                      <label className="uc-label">Title / Subtitle</label>
                      <Form.Item name="title">
                        <TextArea rows={2} placeholder="Enter title" />
                      </Form.Item>
                    </Col>
                  )}
                  {v("author") &&
                    contentType !== "news" &&
                    contentType !== "article" &&
                    contentType !== "njayar" && (
                      <Col sm={v("seriesName") ? 6 : 6} xs={12}>
                        <label className="uc-label">Author</label>
                        <Form.Item name="author">
                          <Input placeholder="Enter author name" />
                        </Form.Item>
                      </Col>
                    )}
                  {v("seriesName") && (
                    <Col sm={6} xs={12}>
                      <label className="uc-label">Series Name</label>
                      <Form.Item name="seriesName">
                        <Input placeholder="Enter series name" />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </div>

              {/* Card: Body Editor */}
              <div className="uc-card">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 12,
                  }}
                >
                  <div
                    className="uc-card-title"
                    style={{
                      marginBottom: 0,
                      paddingBottom: 0,
                      borderBottom: "none",
                      flex: 1,
                    }}
                  >
                    <BsBodyText /> Content Body
                  </div>
                  {contentType === "news" && (
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <Tooltip title="Start / Stop Listening">
                        <Button onClick={handleListening} size="small">
                          {microphone ? (
                            <img
                              src={mic}
                              style={{ width: 10 }}
                              alt="listening"
                            />
                          ) : (
                            <HiMicrophone size={15} />
                          )}
                        </Button>
                      </Tooltip>
                      <Popconfirm
                        title="Reset"
                        description="Are you sure to reset?"
                        onConfirm={confirmResetContent}
                      >
                        <Button size="small">reset</Button>
                      </Popconfirm>
                    </div>
                  )}
                </div>
                <input
                  id="my-file"
                  type="file"
                  name="my-file"
                  style={{ display: "none" }}
                  onChange={() => {}}
                />
                {editorLoading && <Loadingbox />}
                <Editor
                  value={content}
                  init={editorInit}
                  onEditorChange={(c: any) => setContent(c)}
                  onInit={() => setEditorLoading(false)}
                />
              </div>

              {/* Card: Blurb (news only) */}
              {v("blurb") && (
                <div className="uc-card">
                  <div className="uc-card-title">
                    <BsBodyText /> Blurb
                  </div>
                  <ReactQuill
                    theme="snow"
                    value={blurb}
                    onChange={setBlurb}
                    style={{ height: 150, marginBottom: 50 }}
                  />
                </div>
              )}

              {/* Card: Media */}
              <div className="uc-card">
                <div className="uc-card-title">
                  <BsImage /> Media
                </div>
                <div className="uc-images-grid">
                  {v("image1") && (
                    <div className="uc-image-slot">
                      <div className="uc-image-slot-label">
                        {contentType === "news" ? "News Image" : "Image 1"}
                      </div>
                      <ImageItem
                        imageurl={imageuploaddata?.imageurl1}
                        upload={() => {
                          if (!imageuploaddata?.imageurl1) {
                            setImageType("image1");
                            setImageName("Image 1");
                            setImageUploader(true);
                          }
                        }}
                        delete={() => deleteImagesFromList("imageurl1")}
                      />
                    </div>
                  )}
                  {v("image2") && (
                    <div className="uc-image-slot">
                      <div className="uc-image-slot-label">Image 2</div>
                      <ImageItem
                        imageurl={imageuploaddata?.imageurl2}
                        upload={() => {
                          if (!imageuploaddata?.imageurl2) {
                            setImageType("image2");
                            setImageName("Image 2");
                            setImageUploader(true);
                          }
                        }}
                        delete={() => deleteImagesFromList("imageurl2")}
                      />
                    </div>
                  )}
                  {v("socialImage") && (
                    <div className="uc-image-slot">
                      <div className="uc-image-slot-label">Social Image</div>
                      <ImageItem
                        imageurl={imageuploaddata?.imageurl3}
                        upload={() => {
                          if (!imageuploaddata?.imageurl3) {
                            setImageType("image3");
                            setImageName("Social Image");
                            setImageUploader(true);
                          }
                        }}
                        delete={() => deleteImagesFromList("imageurl3")}
                      />
                    </div>
                  )}
                  {v("authorImage") && contentType !== "news" && (
                    <div className="uc-image-slot">
                      <div className="uc-image-slot-label">Author Image</div>
                      <ImageItem
                        imageurl={authorImg || imageuploaddata?.imageurl3}
                        upload={() => {
                          setImageType("authorImg");
                          setImageUploader(true);
                        }}
                        delete={() => setAuthorImg("")}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Card: Audio News Recorder (news only) */}
              {contentType === "news" && v("audio") && (
                <div className="uc-card">
                  <div className="uc-card-title">
                    <BsUpload /> Audio News Recorder
                  </div>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 16 }}
                  >
                    <div
                      className="uc-audio-picker"
                      onClick={() => setAudioRecorderVisible(true)}
                    >
                      <img
                        alt="audio"
                        src={AudioUpload}
                        style={{ width: 40, height: 40 }}
                      />
                      <div
                        style={{ fontSize: 12, color: "#888", marginTop: 4 }}
                      >
                        Click here to record
                      </div>
                    </div>
                    {audiouploader ? (
                      <audio
                        style={{ flex: 1, maxWidth: 400 }}
                        src={audiouploader}
                        controls
                      />
                    ) : null}
                  </div>
                </div>
              )}

              {/* Card: Taxonomy */}
              {contentType !== "article" &&
                contentType !== "editorial" &&
                contentType !== "njayar" &&
                (v("categories") ||
                  v("njayarCategory") ||
                  v("tagString") ||
                  (contentType === "vidya" && v("tags"))) && (
                  <div className="uc-card">
                    <div className="uc-card-title">
                      <BsTag /> Taxonomy
                    </div>
                    <Row>
                      {v("categories") && (
                        <Col sm={6} xs={12}>
                          <label className="uc-label">
                            Categories {contentType === "news" && "*"}
                          </label>
                          <Form.Item
                            name="categories"
                            rules={
                              contentType === "news"
                                ? [
                                    {
                                      required: true,
                                      message: "Category is required",
                                    },
                                  ]
                                : []
                            }
                          >
                            <Select
                              mode="multiple"
                              style={{ width: "100%" }}
                              placeholder="Select categories"
                              filterOption={(input: any, option: any) =>
                                option?.children
                                  ?.toLowerCase()
                                  ?.indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {categories.map((item: any) => (
                                <Select.Option
                                  key={item.id}
                                  value={JSON.stringify({
                                    id: item.id,
                                    category: item?.attributes?.category,
                                  })}
                                >
                                  {item?.attributes?.category}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      )}
                      {v("subcategories") && (
                        <Col sm={6} xs={12}>
                          <label className="uc-label">
                            Sub Categories {contentType === "news" && "*"}
                          </label>
                          <Form.Item
                            name="subcategory"
                            rules={
                              contentType === "news"
                                ? [
                                    {
                                      required: true,
                                      message: "Sub category is required",
                                    },
                                  ]
                                : []
                            }
                          >
                            <Select
                              mode="multiple"
                              style={{ width: "100%" }}
                              placeholder="Select sub categories"
                              filterOption={(input: any, option: any) =>
                                option?.children
                                  ?.toLowerCase()
                                  ?.indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {subcategories.map((item: any) => (
                                <Select.Option key={item.id} value={item.id}>
                                  {item?.attributes?.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      )}
                      {v("njayarCategory") && (
                        <Col sm={6} xs={12}>
                          <label className="uc-label">Category</label>
                          <Form.Item name="njayarCategory">
                            <Select
                              mode="tags"
                              style={{ width: "100%" }}
                              placeholder="Select or add category"
                              filterOption={(input: any, option: any) =>
                                option?.children
                                  ?.toLowerCase()
                                  ?.indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {njayarCategories?.map(
                                (item: any, index: any) => (
                                  <Select.Option
                                    key={index}
                                    value={item?.replace("|", "")}
                                  >
                                    {item?.replace("|", "")}
                                  </Select.Option>
                                ),
                              )}
                            </Select>
                          </Form.Item>
                        </Col>
                      )}
                      {v("tagString") && (
                        <Col sm={6} xs={12}>
                          <label className="uc-label">
                            Tags {contentType === "news" && "*"}
                          </label>
                          <Form.Item
                            name="tagString"
                            rules={
                              contentType === "news"
                                ? [
                                    {
                                      required: true,
                                      message: "Tags are required",
                                    },
                                  ]
                                : []
                            }
                          >
                            <Select
                              mode="tags"
                              style={{ width: "100%" }}
                              placeholder="Add tags"
                              filterOption={(input: any, option: any) =>
                                option?.children
                                  ?.toLowerCase()
                                  ?.indexOf(input.toLowerCase()) >= 0
                              }
                              onSearch={(val) => OnTagSearch(val)}
                              loading={tagLoading}
                            >
                              {tags.map((item: any, index: any) => (
                                <Select.Option key={index} value={item.tag}>
                                  {item.tag}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      )}
                      {contentType === "vidya" && v("tags") && (
                        <Col sm={6} xs={12}>
                          <label className="uc-label">Tags</label>
                          <Form.Item name="tags">
                            <Select
                              mode="multiple"
                              style={{ width: "100%" }}
                              placeholder="Select tags"
                              filterOption={(input: any, option: any) =>
                                option?.children
                                  ?.toLowerCase()
                                  ?.indexOf(input.toLowerCase()) >= 0
                              }
                              onSearch={(val) => OnTagSearch(val)}
                              loading={tagLoading}
                            >
                              {tags.map((item: any) => (
                                <Select.Option key={item.id} value={item.id}>
                                  {item.tag}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  </div>
                )}

              {/* Hidden masterid field (njayar) */}
              {v("masterid") && contentType === "njayar" && (
                <Form.Item name="masterid" hidden>
                  <Input type="hidden" />
                </Form.Item>
              )}
            </Col>

            {/* =================== Sidebar =================== */}
            <Col sm={3} xs={12}>
              <div className="uc-sidebar">
                {/* Sidebar: Permalink */}
                <div className="uc-sidebar-card">
                  <div className="uc-permalink-row">
                    <div className="uc-sidebar-card-title">Perma-Link</div>
                    {(returnedId || data?.id) && (
                      <IoCopyOutline
                        size={16}
                        color="#52c41a"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleUrlCopy("copy")}
                      />
                    )}
                  </div>
                  <Form.Item
                    name="permalink"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();
                          return /^[a-zA-Z0-9- ]*$/.test(value)
                            ? Promise.resolve()
                            : Promise.reject(
                                "Only alphanumeric, spaces, and dashes allowed.",
                              );
                        },
                      },
                    ]}
                  >
                    <TextArea
                      onChange={checkPermaLink}
                      lang="en"
                      placeholder="enter-perma-link"
                      rows={2}
                    />
                  </Form.Item>
                </div>

                {/* Sidebar: Author (article) */}
                {contentType === "article" && v("author") && (
                  <div className="uc-sidebar-card">
                    <div className="uc-sidebar-card-title">Author</div>
                    <Form.Item name="author">
                      <Input placeholder="Enter author name" />
                    </Form.Item>
                  </div>
                )}

                {/* Sidebar: Tags (article, editorial) */}
                {(contentType === "article" || contentType === "editorial") &&
                  v("tagString") && (
                    <div className="uc-sidebar-card">
                      <div className="uc-sidebar-card-title">Tags</div>
                      <Form.Item name="tagString">
                        <Select
                          mode="tags"
                          style={{ width: "100%" }}
                          placeholder="Add tags"
                          filterOption={(input: any, option: any) =>
                            option?.children
                              ?.toLowerCase()
                              ?.indexOf(input.toLowerCase()) >= 0
                          }
                          onSearch={(val) => OnTagSearch(val)}
                          loading={tagLoading}
                        >
                          {tags.map((item: any, index: any) => (
                            <Select.Option key={index} value={item.tag}>
                              {item.tag}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  )}

                {/* Sidebar: Tags (vidya) */}
                {contentType === "vidya" && v("tags") && (
                  <div className="uc-sidebar-card">
                    <div className="uc-sidebar-card-title">Tags</div>
                    <Form.Item name="tags">
                      <Select
                        mode="multiple"
                        style={{ width: "100%" }}
                        placeholder="Select tags"
                        filterOption={(input: any, option: any) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input.toLowerCase()) >= 0
                        }
                        onSearch={(val) => OnTagSearch(val)}
                        loading={tagLoading}
                      >
                        {tags.map((item: any) => (
                          <Select.Option key={item.id} value={item.id}>
                            {item.tag}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}

                {/* Sidebar: Byline (news only) */}
                {contentType === "news" && v("author") && (
                  <div className="uc-sidebar-card">
                    <div className="uc-sidebar-card-title">Byline</div>
                    <Form.Item name="author">
                      <Input placeholder="Enter byline" />
                    </Form.Item>
                  </div>
                )}

                {/* Sidebar: Author Image (news only) */}
                {contentType === "news" && v("authorImage") && (
                  <div className="uc-sidebar-card">
                    <div className="uc-sidebar-card-title">Author Image</div>
                    <ImageItem
                      imageurl={authorImg}
                      upload={() => {
                        setImageType("authorImg");
                        setImageUploader(true);
                      }}
                      delete={() => setAuthorImg("")}
                    />
                  </div>
                )}

                {/* Sidebar: Priority (news) */}
                {(v("isHighPriority") || v("isSecondLeads")) &&
                  contentType === "news" && (
                    <div className="uc-sidebar-card">
                      <div className="uc-sidebar-card-title">Priority</div>
                      <Form.Item name="isHighPriority">
                        <Radio.Group>
                          <Radio value={1}>First leads</Radio>
                          <Radio value={2}>Second leads</Radio>
                          <Radio value={3}>No leads</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                  )}

                {/* Sidebar: Author (njayar) */}
                {contentType === "njayar" && v("author") && (
                  <div className="uc-sidebar-card">
                    <div className="uc-sidebar-card-title">Author</div>
                    <Form.Item name="author">
                      <Input placeholder="Enter author name" />
                    </Form.Item>
                  </div>
                )}

                {/* Sidebar: Tags (njayar) */}
                {contentType === "njayar" && v("tagString") && (
                  <div className="uc-sidebar-card">
                    <div className="uc-sidebar-card-title">Tags</div>
                    <Form.Item name="tagString">
                      <Select
                        mode="tags"
                        style={{ width: "100%" }}
                        placeholder="Add tags"
                        filterOption={(input: any, option: any) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input.toLowerCase()) >= 0
                        }
                        onSearch={(val) => OnTagSearch(val)}
                        loading={tagLoading}
                      >
                        {tags.map((item: any, index: any) => (
                          <Select.Option key={index} value={item.tag}>
                            {item.tag}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}

                {/* Sidebar: Category (njayar) */}
                {contentType === "njayar" && v("njayarCategory") && (
                  <div className="uc-sidebar-card">
                    <div className="uc-sidebar-card-title">Category</div>
                    <Form.Item name="njayarCategory">
                      <Select
                        mode="tags"
                        style={{ width: "100%" }}
                        placeholder="Select or add category"
                        filterOption={(input: any, option: any) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {njayarCategories?.map((item: any, index: any) => (
                          <Select.Option
                            key={index}
                            value={item?.replace("|", "")}
                          >
                            {item?.replace("|", "")}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}

                {/* Sidebar: Priority (njayar) */}
                {v("isHighPriority") && contentType === "njayar" && (
                  <div className="uc-sidebar-card">
                    <div className="uc-sidebar-card-title">Priority</div>
                    <Form.Item name="isHighPriority">
                      <Radio.Group>
                        <Radio value={1}>First leads</Radio>
                        <Radio value={2}>Second leads</Radio>
                        <Radio value={3}>Third leads</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                )}

                {/* Sidebar: On Live (news) */}
                {v("onlive") && (
                  <div className="uc-sidebar-card">
                    <div className="uc-sidebar-card-title">On Live</div>
                    <Form.Item name="onlive" valuePropName="checked">
                      <Switch />
                    </Form.Item>
                  </div>
                )}

                {/* Sidebar: Meta Title */}
                {v("metaTitle") && (
                  <div className="uc-sidebar-card">
                    <div className="uc-sidebar-card-title">Meta Title</div>
                    <Form.Item name="metaTitle">
                      <TextArea rows={2} placeholder="SEO meta title" />
                    </Form.Item>
                  </div>
                )}

                {/* Sidebar: Meta Description */}
                {v("metaDescription") && (
                  <div className="uc-sidebar-card">
                    <div className="uc-sidebar-card-title">
                      Meta Description
                    </div>
                    <Form.Item name="metaDescription">
                      <TextArea rows={4} placeholder="SEO meta description" />
                    </Form.Item>
                  </div>
                )}

                {/* Sidebar: Author (news, display only) */}
                {contentType === "news" && (
                  <div className="uc-sidebar-card">
                    <div className="uc-sidebar-card-title">Author</div>
                    <Input disabled value={User?.username} />
                  </div>
                )}

                {/* Sidebar: Social Share Preview (news) */}
                {contentType === "news" && (
                  <Button
                    block
                    type="primary"
                    size="large"
                    disabled={!(returnedId || data?.id)}
                    onClick={() => setSocialShareModal(true)}
                    style={{ marginBottom: 16 }}
                  >
                    Social Share Preview
                  </Button>
                )}

                {/* Sidebar: Post Impressions (news, edit mode) */}
                {contentType === "news" &&
                  data &&
                  (returnedId || data?.id) &&
                  (() => {
                    const attrs = data?.attributes || data;
                    return (
                      <div className="uc-sidebar-card">
                        <div
                          className="uc-sidebar-card-title"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Post Impressions</span>
                          <SiGoogleanalytics size={14} color="#0055a6" />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "6px 0",
                            fontSize: 13,
                          }}
                        >
                          <span>Views</span>
                          <span style={{ fontWeight: 600 }}>
                            {attrs?.View ? `${attrs.View} +` : "0"}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "6px 0",
                            fontSize: 13,
                          }}
                        >
                          <span>Share</span>
                          <span style={{ fontWeight: 600 }}>
                            {attrs?.shares ? `${attrs.shares} +` : "0"}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingTop: 10,
                            marginTop: 10,
                            borderTop: "1px solid #f0f2f5",
                            cursor: "pointer",
                          }}
                          onClick={() => setNewsLogVisible(true)}
                        >
                          <span
                            style={{
                              color: "#0055a6",
                              fontWeight: 600,
                              fontSize: 13,
                            }}
                          >
                            Revisions ({attrs?.logs?.count || 0})
                          </span>
                          <MdPublishedWithChanges size={16} color="#0055a6" />
                        </div>
                      </div>
                    );
                  })()}
              </div>
            </Col>
          </Row>

          {/* ---- Action Bar ---- */}
          <div className="uc-action-bar">
            {/* NEWS: single-step save/publish/schedule */}
            {contentType === "news" && (
              <>
                {v("scheduled_at") && (
                  <Button
                    disabled={
                      publishedStatus === "published" ||
                      publishedStatus === "scheduled"
                    }
                    loading={scheduleLoading}
                    onClick={() => {
                      setTempScheduled(scheduled || null);
                      setShowScheduleModal(true);
                    }}
                    icon={<BsClock />}
                  >
                    {publishedStatus === "scheduled"
                      ? "Reschedule"
                      : "Schedule"}
                  </Button>
                )}
                <Button
                  type="primary"
                  disabled={
                    publishedStatus === "published" ||
                    publishedStatus === "scheduled"
                  }
                  loading={publishLoading}
                  onClick={() => handleAction("publish")}
                  icon={<BsUpload />}
                >
                  Publish
                </Button>
                <Button
                  loading={loading}
                  type="default"
                  onClick={() => handleAction("save")}
                >
                  {isEditing ? "Update" : "Save"}
                </Button>
              </>
            )}

            {/* ARTICLE: single-step save/publish */}
            {contentType === "article" && (
              <>
                <Button
                  type="primary"
                  disabled={publishedStatus === "published"}
                  loading={publishLoading}
                  onClick={() => handleAction("publish")}
                  icon={<BsUpload />}
                >
                  Publish
                </Button>
                <Button
                  loading={loading}
                  type="default"
                  onClick={() => handleAction("save")}
                >
                  {isEditing ? "Update" : "Save"}
                </Button>
              </>
            )}

            {/* EDITORIAL: two-step save then publish */}
            {contentType === "editorial" && (
              <>
                <Button
                  type="primary"
                  disabled={!returnedId}
                  loading={publishLoading}
                  onClick={onPublish}
                  icon={<BsUpload />}
                >
                  Publish
                </Button>
                <Button htmlType="submit" loading={loading} type="default">
                  {isEditing ? "Update" : "Save"}
                </Button>
              </>
            )}

            {/* VIDYA: two-step with schedule/publish (hidden when published) */}
            {contentType === "vidya" && (
              <>
                {publishedStatus !== "published" && (
                  <>
                    {v("scheduled_at") && (
                      <Button
                        disabled={!returnedId}
                        loading={scheduleLoading}
                        onClick={() => {
                          setTempScheduled(scheduled || null);
                          setShowScheduleModal(true);
                        }}
                        icon={<BsClock />}
                      >
                        {publishedStatus === "scheduled"
                          ? "Reschedule"
                          : "Schedule"}
                      </Button>
                    )}
                    <Button
                      type="primary"
                      disabled={!returnedId}
                      loading={publishLoading}
                      onClick={onPublish}
                      icon={<BsUpload />}
                    >
                      Publish
                    </Button>
                  </>
                )}
                <Button htmlType="submit" loading={loading} type="default">
                  {isEditing ? "Update" : "Save"}
                </Button>
              </>
            )}

            {/* NJAYAR: two-step (publish shown only when ID exists) */}
            {contentType === "njayar" && (
              <>
                {(returnedId || data?.id) && (
                  <Button
                    type="primary"
                    loading={publishLoading}
                    onClick={onPublish}
                    icon={<BsUpload />}
                  >
                    Publish
                  </Button>
                )}
                <Button htmlType="submit" loading={loading} type="default">
                  {isEditing ? "Update" : "Save"}
                </Button>
              </>
            )}
          </div>
        </div>
      </Form>

      {/* Image Picker Modal */}
      {imageUploader && (
        <ImagePicker
          mode="create"
          imageType={imageType}
          imageName={imageName}
          onSelect={addImageToEditor}
          onSubmit={(val: any) => addImagesToList(val)}
          visible={imageUploader}
          close={() => setImageUploader(false)}
        />
      )}

      {/* Audio Recorder Modal */}
      {audioRecorderVisible && (
        <Audiorecorder
          getData={(data: any) => setAudiouploader(data)}
          visible={audioRecorderVisible}
          close={() => setAudioRecorderVisible(false)}
        />
      )}

      {/* Also Read Modal (News) */}
      {alsoRead && (
        <AlsoRead
          visible={alsoRead}
          close={() => setAlsoRead(false)}
          onSubmit={(val: any) => addAlsoRead(val)}
        />
      )}

      {/* Custom Button / Media Join Modal (News) */}
      {customButton && (
        <MediaJoin
          onSubmit={(val: any) => addButtonMedia(val)}
          visible={customButton}
          close={() => setCustomButton(false)}
        />
      )}

      {/* News Log / Revisions Modal */}
      {newsLogVisible && (
        <NewsLog
          visible={newsLogVisible}
          id={(data?.attributes || data)?.id || returnedId}
          close={() => setNewsLogVisible(false)}
        />
      )}

      {/* Social Share Preview Modal (News) */}
      {socialShareModal && (
        <SocialShare
          image={imageuploaddata?.imageurl3 || imageuploaddata?.imageurl1}
          data={data?.attributes || data}
          visible={socialShareModal}
          onCancel={() => setSocialShareModal(false)}
        />
      )}

      {/* Preview Modal (News) */}
      {showPreview && (
        <PreviewModal
          open={showPreview}
          footer={false}
          onCancel={() => setShowPreview(false)}
          preview={() => handleUrlCopy("preview")}
          data={previewDatas}
        />
      )}

      {/* Social Embed Modal (News) */}
      {socialEmbedModal && (
        <SocialEmbedModal
          visible={socialEmbedModal}
          onCancel={() => setSocialEmbedModal(false)}
          onSubmit={(val: any) => addSocialEmbed(val)}
          initialValue={socialEmbed}
        />
      )}

      {/* Schedule Modal */}
      <Modal
        centered
        title={
          publishedStatus === "scheduled"
            ? `Reschedule ${CONTENT_TYPE_LABELS[contentType]}`
            : `Schedule ${CONTENT_TYPE_LABELS[contentType]}`
        }
        open={showScheduleModal}
        onCancel={() => setShowScheduleModal(false)}
        okText="Schedule"
        okButtonProps={{
          disabled:
            !tempScheduled ||
            (tempScheduled && tempScheduled.isBefore(dayjs())),
        }}
        onOk={async () => {
          if (!tempScheduled) {
            message.error("Please select a date and time");
            return;
          }
          if (tempScheduled.isBefore(dayjs())) {
            message.error("Cannot schedule for past date/time");
            return;
          }
          setScheduled(tempScheduled);
          setShowScheduleModal(false);
          // For news: single-step schedule via handleAction with scheduleTime param
          if (contentType === "news") {
            handleAction("schedule", tempScheduled);
          } else {
            // For vidya/others: two-step schedule via onSchedule
            const scheduleId = returnedId || data?.id;
            if (!scheduleId) {
              message.error("Please save first");
              return;
            }
            setScheduleLoading(true);
            const endpoints = API_ENDPOINTS[contentType];
            try {
              await axios.put(API.BASE_URL + endpoints.publish(scheduleId), {
                data: {
                  scheduled_at: tempScheduled.toISOString(),
                  publishedAt: null,
                },
              });
              message.success("Scheduled Successfully");
              setScheduleLoading(false);
              navigate(
                contentType === "njayar" && masterId
                  ? `/Auth/unified-content/njayar/master/${masterId}`
                  : "/Auth/unified-content"
              );
            } catch {
              setScheduleLoading(false);
              message.error("Failed to schedule");
            }
          }
        }}
      >
        <p style={{ marginBottom: 16, color: "#666" }}>
          Select the date and time to publish:
        </p>
        <DatePicker
          showTime={{ use12Hours: true, format: "h:mm A" }}
          format="DD-MM-YYYY h:mm A"
          placeholder="Select scheduled date and time"
          size="large"
          style={{ width: "100%" }}
          value={tempScheduled}
          onChange={(value: any) => {
            if (value) {
              setTempScheduled(value.tz("Asia/Kolkata"));
            } else {
              setTempScheduled(null);
            }
          }}
          showNow={true}
          disabledDate={(current) =>
            current && current < dayjs().startOf("day")
          }
        />
      </Modal>
    </div>
  );
}

export default UnifiedForm;
